import React from 'react';
import type { FC } from 'react';
import { Alert, Badge, Box, Spinner, Text, useAsync } from '@wix/cli-ui-kit';
import { match } from 'variant';
import { useFunnelProjectsClient } from '@wix/funnel-projects-client';

export const CreateBusiness: FC<{
  businessName: string;
  businessTemplateId: string;
  onDone: (data: { businessId: string }) => void;
}> = ({ businessName, businessTemplateId, onDone }) => {
  const { createProject } = useFunnelProjectsClient();

  const { status } = useAsync(async () => {
    const { project } = await createProject(businessName, businessTemplateId);
    onDone({ businessId: project.metaSiteId });
  }, []);

  return (
    <>
      {match(status, {
        Error: () => null,
        Loading: () => (
          <Box marginBottom={1}>
            <Spinner text="Creating your business..." />
          </Box>
        ),
        Success: () => (
          <Box marginLeft={-2} marginBottom={1}>
            <Alert type="success">
              <Badge skin="success">Success</Badge>{' '}
              <Text>Business created.</Text>
            </Alert>
          </Box>
        ),
        NotRequested: () => null,
      })}
    </>
  );
};
